import { useContext, useEffect, useState } from 'react';
import { ProductListingContext } from '../../functions/data_formatting_functions';
import CustomAttributeModal from './components/add_custom_attribute_modal';
import AttributesSelectionArea from './components/attribute_selection_area';
import styled from 'styled-components';
import { StoreDetails } from '../../../../data/types/stores';
import { ApiRepository } from '../../../../data/repositories/base_repository';
import { S3ApiRepository } from '../../../../data/repositories/s3_repository';
import {
  ListingState,
  TableCombination,
} from '../../../../data/types/listings';

type SpecificationsProps = {
  currentStore?: StoreDetails;
  addStep: (toAdd?: number) => void;
  remove: () => void;
  actionGetStoreImages?: (payload: any) => { type: string; payload: any };
  s3Repository: S3ApiRepository;
  filesRepository: ApiRepository;
};

export default function Specifications({
  currentStore,
  addStep,
  remove,
  s3Repository,
  filesRepository,
  actionGetStoreImages, //TODO
}: SpecificationsProps) {
  const {
    state,
  }: {
    state: ListingState;
  } = useContext(ProductListingContext);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    // Checking if there is any changes in the atrributes values
    setTimeout(() => {
      if (state.data?.combinations_table?.length > 0) {
        let changed = false;
        state.data.combinations_table.forEach((element: TableCombination) => {
          if (
            Object.keys(element.attrs).length !== state.all_attributes.length
          ) {
            changed = true;
          }
        });

        if (changed) {
          console.log('changed');
        }
      }
    }, 1000);
  }, [
    state.data.select_attrs,
    state.data.boolean_attrs,
    state.data.numeric_attrs,
    state.all_attributes,
  ]);

  console.log('specifications screen state: ', state);
  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <GridRow>
        <AttributesSelectionArea
          actionGetStoreImages={actionGetStoreImages}
          currentStore={currentStore}
          remove={remove}
          addStep={addStep}
          setIsModalVisible={setIsModalVisible}
          s3Repository={s3Repository}
          filesRepository={filesRepository}
        />
      </GridRow>
      <CustomAttributeModal
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
}
const GridRow = styled.div`
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .main-page{
    width: 70% 
    max-width: 70%
  }
`;
